/* Boboné — per-color PDP gallery filter (Option B).
   When a product has photos grouped by color, selecting a color shows only
   that color's slides + thumbnails (front and detail shots), plus any
   "universal" shots that carry no color tag. Everything else is hidden.

   Data hooks (emitted by snippets/product-media-gallery.liquid):
     <media-gallery data-bobone-color-option="N">   N = 1-based position of the Color option
     li[data-bobone-color="<color>"]                  "" = universal, else lowercased color name

   Timing: we filter on load and on Dawn's `variant-change` event, which the
   product-info component publishes AFTER it has reconciled/reordered the
   gallery for the new variant — so our filter always runs on settled DOM.

   Safe by design: products with no color tags leave every slide untagged
   (color = ""), so nothing is hidden — identical to stock Dawn behaviour. */
(function () {
  var HIDDEN = 'bobone-color-hidden';

  function norm(value) {
    return (value == null ? '' : String(value)).trim().toLowerCase();
  }

  function galleryFor(sectionId) {
    return document.getElementById('MediaGallery-' + sectionId);
  }

  function sectionIdOf(gallery) {
    return gallery.id.replace('MediaGallery-', '');
  }

  // Read the currently-selected color from the section's serialized variant.
  function selectedColorFromDom(sectionId, position) {
    var vs = document.getElementById('variant-selects-' + sectionId);
    if (!vs) return '';
    var script = vs.querySelector('[data-selected-variant]');
    if (!script) return '';
    try {
      return colorFromVariant(JSON.parse(script.textContent), position);
    } catch (e) {
      return '';
    }
  }

  function colorFromVariant(variant, position) {
    if (!variant) return '';
    if (Array.isArray(variant.options) && variant.options[position - 1] != null) {
      return norm(variant.options[position - 1]);
    }
    return norm(variant['option' + position]); // fallback
  }

  // Show slides whose color matches (or that are universal); hide the rest.
  // If a color ends up with nothing to show, reveal everything (never blank).
  function filterList(items, selected) {
    var anyTagged = false;
    var visible = 0;
    items.forEach(function (li) {
      var color = norm(li.dataset.boboneColor);
      if (color) anyTagged = true;
      var show = color === '' || color === selected;
      li.classList.toggle(HIDDEN, !show);
      if (show) visible += 1;
    });
    if (!anyTagged || visible === 0) {
      items.forEach(function (li) { li.classList.remove(HIDDEN); });
      return items.length;
    }
    return visible;
  }

  function filter(gallery, selected) {
    if (!gallery) return;
    var position = parseInt(gallery.dataset.boboneColorOption, 10);
    if (!position) return;

    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');

    var slides = viewer ? Array.prototype.slice.call(viewer.querySelectorAll('li[data-bobone-color]')) : [];
    var visibleCount = filterList(slides, selected);
    if (thumbs) {
      filterList(Array.prototype.slice.call(thumbs.querySelectorAll('li[data-bobone-color]')), selected);
    }

    // Keep the slide counter honest.
    var total = gallery.querySelector('.slider-counter--total');
    if (total) total.textContent = visibleCount;
    var current = gallery.querySelector('.slider-counter--current');
    if (current) current.textContent = '1';

    // If the active slide got hidden, promote the first visible one.
    var active = viewer && viewer.querySelector('li.is-active');
    if (active && active.classList.contains(HIDDEN)) {
      var firstVisible = viewer.querySelector('li[data-media-id]:not(.' + HIDDEN + ')');
      if (firstVisible && gallery.setActiveMedia) {
        gallery.setActiveMedia(firstVisible.dataset.mediaId, true);
      }
    }
  }

  function initGallery(gallery) {
    var sectionId = sectionIdOf(gallery);
    var position = parseInt(gallery.dataset.boboneColorOption, 10);
    if (!position) return;
    filter(gallery, selectedColorFromDom(sectionId, position));
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll('media-gallery[data-bobone-color-option]')
      .forEach(initGallery);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  // React to variant/color changes (published after product-info swaps media).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data) return;
      var gallery = galleryFor(data.sectionId);
      if (!gallery) return;
      var position = parseInt(gallery.dataset.boboneColorOption, 10);
      if (!position) return;
      filter(gallery, colorFromVariant(data.variant, position));
    });
  }
})();
